import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app';
import { AppRoutingModule } from './app-routing-module';;
import { LayoutModule } from './layout/layout-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { LucideAngularModule, Globe } from 'lucide-angular';
import { TRANSLATION_CONFIG } from './core/translation.config';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';


@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, LayoutModule,
    ReactiveFormsModule, FormsModule, BrowserAnimationsModule, HttpClientModule, LucideAngularModule.pick({ Globe }),
    GoogleTagManagerModule.forRoot({
      id: environment.gtmKey
    })],
  providers: [
    provideHttpClient(withFetch()),
    {
      provide: TRANSLATION_CONFIG,
      useValue: {
        languages: [
          { code: 'en', name: 'English' },
          { code: 'es', name: 'Spanish' },
          { code: 'de', name: 'German' },
          { code: 'pt', name: 'Portuguese' }
        ],
        default: 'en',
        useUrl: true
      }
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
        size: 'invisible'
      } as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
